<template>
  <el-dialog
    title="机构员工"
    :visible.sync="visible"
    width="560px"
    append-to-body=""
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.userName"
        placeholder="请输入姓名"
        clearable=""
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      max-height="600"
      border
      :data="list">
      <el-table-column
        label="姓名"
        prop="userName"></el-table-column>
      <el-table-column
        label="手机号"
        width="120"
        prop="mobilePhone"></el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="60">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            :disabled="row.isAdmin === 1"
            @click="deleteitem(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Verification from '@/service/verification'
export default {
  name: 'CorpStaffModal',
  data() {
    return {
      loading: false,
      visible: false,
      config: { pageNum: 1, pageSize: 10, userName: '', verificationCorpId: null },
      list: [],
      total: 0
    }
  },
  methods: {
    deleteitem(row) {
      console.log(row)
      this.$confirm(`您确定删除该机构员工?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Verification.deleteverificationuser({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleClosed() {
      this.list = []
      this.total = 0
      this.config = { ...this.config, ...this.$options.data().config }
      this.$emit('fetch')
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Verification.getverificationusers({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options) {
      this.config.verificationCorpId = options.verificationCorpId
      this.fetchList()
      this.visible = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
